import { createContext } from 'react';
import type { SearchModel } from 'autogen/swagger/all';

export const SearchTextContext = createContext<{
    searchText: SearchModel['searchText'];
} | null>(null);
